$(document).ready(function () {

  $(document).on('input', '#search--bar', function () {
      var searchText = $(this).val().toLowerCase();
      $('.s__content.active-content .card--holder').each(function () {
          var cardTitle = $(this).find('.card__info .card__title').text().toLowerCase();
          if (cardTitle.includes(searchText)) {
              $(this).show();
          } else {
              $(this).hide();
          }
      });
  });
  $(document).on('click', '.search--clear', function () {
      $(this).siblings('#search--bar').val('').trigger('input');
  });
  
  
  $(".tab-collection .s__content").eq(0).show().addClass("active-content");
  $(".tabmenu-center .tab--items").eq(0).addClass("active-tab");

  $(".tabmenu-center .tab--items").click(function () {
    var $this = $(this);
    var $target = $this.attr("data-target");
    $(".tab-collection .s__content").hide().removeClass("active-content");

    $(".tabmenu-center .tab--items").removeClass("active-tab");
    $this.addClass("active-tab");

    $($target).show().addClass("active-content");
    $('.search--clear').trigger('click');
  });

  $(document).on('click', '.custom--atc', function () {
      $(this).parents('.active-content .card--holder').addClass("selected");
      $(this).parents('.active-content .card--holder').find('.product_counters').css('display', 'inline-flex');
      $(this).parents('.active-content .card--holder').find('.added_to_cart').show();
      $(this).hide();
      var chhosen_title = $(this).attr('data-title');
      $(this).parents('.custom-bb').find('.Message_Bar').removeClass('is-hidden').find('.Message-body span').empty().text(chhosen_title);
      setTimeout(()=>{
        $(this).parents('.custom-bb').find('.Message_Bar').addClass('is-hidden').find('.Message-body span').empty();
      }, 2000);
      $(this).siblings('.custom--remove').show();
      var selectedPDP = $('.s__content.active-content .row .card--holder.selected').length;
      $('#checkproduct').attr('data-pdpnum', selectedPDP);
      $(this).parents('.custom-bb').find('.tabmenu-center .active-tab .pdp__checked').show().find('.no-cho').show().text(selectedPDP);

      var activTabNo = $(this).parents('.custom-bb').find('.s__content.active-content').attr("data-active-coll-pdp-no");
      if(activTabNo == selectedPDP){
          $('.s__content.active-content .row .card--holder').not('.selected').find('.custom--atc').addClass('indisable');
          $(this).parents('.custom-bb').find('.tabmenu-center .active-tab .pdp__checked svg.pdpcheck-icon').show();
          $(this).parents('.custom-bb').find('.tabmenu-center .active-tab .pdp__checked').show().find('.no-cho').hide().text(selectedPDP)
          $('.tab--items.active-tab').next('.tab--items').trigger('click');
          
      }
      var pdp_id = $(this).siblings('input[name="id"]').val(),
          pdp_price = $(this).attr('data-price'),
          newspan = $(`<span class="choosen-pdp pdp--${selectedPDP}" data-choosen-id="${pdp_id}" data-pdpprice="${pdp_price}" data-fill="true"></span>`);
      $('.selected-item-id').append(newspan);
      // var beforeSelcted = $('#checkproduct').attr('data-pdpnum'),
          var beforeSelcted = $('.selected-item-id span').length,
          neededselected = $('.tab-collection').attr('data-numberneeded');
          if (beforeSelcted == neededselected){
              $('.s__content.active-content .row .card--holder').not('.selected').find('.custom--atc').addClass('indisable');
          }
      
      var totalPrice = 0;
        $('.selected-item-id').find('.choosen-pdp').each(function() {
            var price = parseFloat($(this).attr('data-pdpprice')) || 0;
            totalPrice += price;
        });
        
        
        $('.jsmoney-wrap').find('.jsmoney').text(`₹${totalPrice}`);
        if (beforeSelcted == neededselected){
          $('.jsmoney-wrap').show();
          $('.bb-addtocart').show();
          $(this).parents('.custom-bb').find('.tabmenu-center .pdp__checked svg.pdpcheck-icon').show();
          $(this).parents('.custom-bb').find('.tabmenu-center .pdp__checked').show().find('.no-cho').hide().text(selectedPDP);
        }
  });
  $(document).on('click', '.custom--remove', function () {
      $(this).parents('.active-content .card--holder').removeClass("selected");
      $(this).parents('.active-content .card--holder').find('.product_counters').hide();
      $(this).parents('.active-content .card--holder').find('.added_to_cart').hide();
      $(this).hide();
      $(this).siblings('.custom--atc').show();
      var selectedPDP = $('.s__content.active-content .row .card--holder.selected').length;
      $('#checkproduct').attr('data-pdpnum', selectedPDP);
    $(this).parents('.custom-bb').find('.tabmenu-center .active-tab .pdp__checked').show().find('.no-cho').show().text(selectedPDP);
      var activTabNo = $(this).parents('.custom-bb').find('.s__content.active-content').attr("data-active-coll-pdp-no");
      
      if(activTabNo > selectedPDP){
          $('.s__content.active-content .row .card--holder').not('.selected').find('.custom--atc').removeClass('indisable');
          $(this).parents('.custom-bb').find('.tabmenu-center .active-tab .pdp__checked svg.pdpcheck-icon').hide();
          // $(this).parents('.custom-bb').find('.tabmenu-center .active-tab .pdp__checked').show().find('.no-cho').hide().text(selectedPDP)
          if(selectedPDP == 0){
            $(this).parents('.custom-bb').find('.tabmenu-center .active-tab .pdp__checked').hide();
          }
          
      }
      var pdp_id = $(this).siblings('input[name="id"]').val(),
          pdp_price = $(this).attr('data-price');
      $('.selected-item-id').find('span[data-choosen-id="' + pdp_id + '"]').remove();
      var totalPrice = 0;
        $('.selected-item-id').find('.choosen-pdp').each(function() {
            var price = parseFloat($(this).attr('data-pdpprice')) || 0;
            totalPrice += price;
        });
        $('.jsmoney-wrap').find('.jsmoney').text(`₹${totalPrice}`);
      var beforeSelcted = $('.selected-item-id span').length,
       neededselected = $('.tab-collection').attr('data-numberneeded');
      if (beforeSelcted < neededselected){
          $('.s__content.active-content .row .card--holder').not('.selected').find('.custom--atc').removeClass('indisable');
      }
      
        setTimeout(()=>{
          if (beforeSelcted < neededselected){
            $('.jsmoney-wrap').hide();
            $('.bb-addtocart').hide();
            $(this).parents('.custom-bb').find('.tabmenu-center .active-tab .pdp__checked svg.pdpcheck-icon').hide();
          }
          if(beforeSelcted == 0){
            $(this).parents('.custom-bb').find('.tabmenu-center .pdp__checked').hide();
          }
        }, 0)
        
  });
  

  $(document).on('click', '.bb-addtocart', function(){
    var neededselected = $('.tab-collection').attr('data-numberneeded'),
      noIs = $('.selected-item-id .choosen-pdp').length,
      thresValue = $('.custom-bb').attr('data-thrsholdvalue'),
      numbrneed = $('.custom-bb').attr('data-numberneeded');
    if(noIs == 3){
      var __id = "MkLvGp1WzHd9oR";
    } else if(noIs == 4){
      var __id = "LzVqXp0FaTmPj8Y";
    } else if (noIs == 5){
      var __id = "QeNkVoPj3WzJf6B";
    } else if (noIs == 6){
      var __id = "RhLk1VrDxXyQz7U";
    } else{
      console.log("no offers available");
    }
    
   
    if(noIs == neededselected){
    var all_ids = [],
     timeSpan = new Date().getTime(), 
     properties = {
        __source: "fixed_price_bundle",
        __connected_id: timeSpan,
        __id: __id,
       __offer_type: thresValue
       // __threshould_value: numbrneed
    };

    
    $('.selected-item-id').find('.choosen-pdp').each(function() {
        var choosenId = $(this).attr('data-choosen-id');
        all_ids.push(choosenId);
    });
    
    function addToCart(ids) {
        var itemsToAdd = ids.map(function(id) {
            return { id: id, quantity: 1, properties: properties };
        });
        console.log(itemsToAdd);
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: JSON.stringify({ items: itemsToAdd }),
            dataType: 'json',
            contentType: 'application/json',
            success: function(response) {
                console.log(response);
                $('.cart__drawer').addClass('show-cart__drawer');
                $('body').addClass('cv--show-cart__drawer');
                 window.cartRefresh();
            },
            error: function(error) {
                console.error('Failed to add items to the cart:', error);
            }
        });
    }
    
    addToCart(all_ids);
      }
    });
  
});



